module.exports = __webpack_public_path__ + "static/media/m_beard_tailored_round__oval_vector.b67892e5.svg";